import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import PrivateRoute from "./PrivateRoute";



import Dash from "../pages/dash/Dash";
import CriarEventos from "../pages/criarEventos/CriarEventos";
import Eventos from "../pages/eventos/Eventos";
import Conquistas from "../pages/conquistas/Conquistas";
import Login from "../pages/login/Login";
import Oportunidades from "../pages/oportunidades/Oportunidades";
import Cursos from "../pages/cursos/Cursos";
import Criarconquista from "../pages/criarConquistas/CriarConquistas";
import EditarEventos from "../pages/editarEventos/EditarEventos";
import EditarOportunidades from "../pages/editarOportunidades/EditarOportunidades";
import EditarConquistas from "../pages/editarConquistas/EditarConquistas"; 
import CriarOportunidades from "../pages/criarOportunidades/CriarOportunidades";
import EditarCursos from "../pages/editarCursos/EditarCursos";
import { EventosProvider } from "../context/EventosContext";
import { OportunidadesProvider } from "../context/OportunidadesContext";
import CriarCursos from "../pages/criarCursos/CriarCursos";
import Relatorios from "../pages/relatorios/Relatorios";
import { CursosProvider } from "../context/CursosContext";

function AppRoutes() {
  return (
    <CursosProvider>
      <OportunidadesProvider>
        <EventosProvider>
          <Router>
            <Routes>
              {/* totas publicas */}
              <Route path="/" element={<Login />} />
              <Route path="/login" element={<Login />} />


              <Route element={<PrivateRoute />}>
              <Route path="/dash" element={<Dash />} />
              <Route path="/eventos" element={<Eventos />} />
              <Route path="/criar-evento" element={<CriarEventos />} />
              <Route path="/conquistas" element={<Conquistas />} />
              <Route path="/criar-conquista" element={<Criarconquista />} />
              <Route path="/editar-conquistas/:id" element={<EditarConquistas />} />
              <Route path="/oportunidades" element={<Oportunidades />} />
              <Route
                path="/criar-oportunidade"
                element={<CriarOportunidades />}
              />
              <Route path="/cursos" element={<Cursos />} />
              <Route path="/editar-evento/:id" element={<EditarEventos />} />
              <Route
                path="/editar-oportunidades/:id"
                element={<EditarOportunidades />}
              />
              <Route path="/novo-curso" element={<CriarCursos />} />
              <Route path="/editar-curso/:id" element={<EditarCursos />} />

              <Route path="/relatorios" element={<Relatorios />} />
              </Route>
            </Routes>
          </Router>
        </EventosProvider>
      </OportunidadesProvider>
    </CursosProvider>
  );
}

export default AppRoutes;
